import React, { useMemo } from 'react';
import LclKanbanColumn from './LclKanbanColumn';
import LclOperationCard from '../LclOperationCard';

/**
 * Columna "Operaciones en curso" — agrupa solicitudes LCL en estado `Enviada`.
 *
 * Archivo independiente para poder ajustar esta columna sin tocar
 * las otras tres ni nada del módulo aéreo.
 */
const LclEnCursoColumn = ({
  items = [],
  onAction,
  loading = false,
  headerExtra,
  actionsMode = 'full',
}) => {
  // `renderItem` se memoriza para no recrearlo en cada render del padre
  const renderItem = useMemo(
    () => (r) => (
      <LclOperationCard
        r={r}
        variant="en-curso"
        onAction={onAction}
        actionsMode={actionsMode}
      />
    ),
    [onAction, actionsMode],
  );

  return (
    <LclKanbanColumn
      id="en-curso"
      title="Operaciones en curso"
      accent="border-t-blue-500"
      badge="bg-blue-100 text-blue-800 border-blue-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin operaciones en curso"
      headerExtra={headerExtra}
    />
  );
};

export default LclEnCursoColumn;
